<div class="login-page">
  <section class="hero-section">
    <div class="main-content">
      <div class="left-content">
        <p class="template-base-eyebrow">SUS · SAES · Radioterapia</p>
        <h1 class="template-base-title">SIMRAD — Sistema de<br>Monitoramento em<br><span>Radioterapia</span></h1>
        <p class="template-base-subtitle">
          Plataforma para cadastro e gestão do serviço de radioterapia em estabelecimentos habilitados como CACONs, UNACONs e prestadores de Radioterapia para o SUS — com validação pelo Ministério da Saúde e rastreabilidade completa.
        </p>
      </div>

      <div class="right-content">
        <div class="login-card-wrapper">
          <div class="card-shadow-3"></div>
          <div class="card-shadow-2"></div>
          <div class="card-shadow-1"></div>
          <div class="login-card">
            <div class="person-badge">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z" fill="currentColor"/>
              </svg>
              <span>Pessoa Física</span>
            </div>

            <h2>Bem-vindo (a)!</h2>

            @if (mensagemEncerramento) {
              <div class="aviso-sessao" role="alert">{{ mensagemEncerramento }}</div>
            }

            <p>Acesso via SSO (Keycloak) com autenticação segura OAuth 2.0 / OpenID Connect.</p>

            <app-button
              [label]="'Entrar'"
              [type]="ButtonType.PRIMARY"
              [disabled]="isRedirecting"
              [noMargin]="true"
              (action)="login()"
            ></app-button>

            @if (isRedirecting) {
              <p class="redirecting-hint">Redirecionando para autenticação...</p>
            }

            <div class="aviso-info" role="note">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor"/>
              </svg>
              <span>
                Primeiro acesso? Após autenticar, utilize o cadastro de serviço conforme as permissões do seu perfil.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-cards-wrapper d-none">
      <div class="info-cards-container">
        <div class="info-card card-editais">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z" fill="currentColor"/>
              </svg>
            </div>
            <h3>Editais</h3>
          </div>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse scelerisque urna ut magna bibendum, eget malesuada</p>
          <button type="button">Acessar editais</button>
        </div>

        <div class="info-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z" fill="currentColor"/>
              </svg>
            </div>
            <h3>Título</h3>
          </div>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse scelerisque urna ut magna bibendum, eget malesuada</p>
          <button type="button">Acessar</button>
        </div>
      </div>
    </div>
  </section>

  <footer class="footer">
    <app-institutional-signature variant="light" layout="footer" />
  </footer>
</div>